import React from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Icon, UiButton, UiText } from '@shared/ui';

import cls from './OnlyAdminToConnectModal.module.css';

export const OnlyAdminToConnectModal = ({
    isOpen,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
}) => {
    const { t } = useTranslation();
    return (
        <CustomModal
            isOpen={isOpen}
            onHideModal={onClose}
            closeButtonClass={cls.closeBtn}
            contentClasses={cls.modalContent}
        >
            <CustomModal.Body width="474px" classes={cls.modalBody}>
                <Icon iconName="cursorInQr" />
                <UiText variant="subHeading" weight="bold" className={cls.subHeading}>
                    {t('WidgetShop.OnlyAdminToConnectModal.title')}
                </UiText>
                <UiText variant="plain">{t('WidgetShop.OnlyAdminToConnectModal.subTitle')}</UiText>
            </CustomModal.Body>
            <CustomModal.Footer classes={cls.modalFooter}>
                <UiButton btnText={t('button.ok.text')} onClick={onClose} />
            </CustomModal.Footer>
        </CustomModal>
    );
};
